import styled from 'styled-components';

import {media} from '../../styles/components/media-queries';

export const PaymentIconsStyled = styled.div`
  display: flex;
  padding-top: 0.6rem;
  padding-left: ${p => p.theme.sideBasket.paymentIcon.paddingLeft};
  padding-bottom: ${p => p.theme.sideBasket.paymentIcon.paddingBottom};
  ${media.medium`
    padding-top: 0;
  `};
  ${media.small`
    padding-top: 0.6rem;
  `};
`;

export const PaymentIcon = styled.div`
  padding-right: ${props => props.theme.sideBasket.paymentIcon.paddingRight};
  ${media.medium`
    svg {
      width: 3.6rem;
      height: 2rem;
    }
    img {
      height: 2rem;
    }
  `};
`;



// WEBPACK FOOTER //
// ./components/PaymentIcons/PaymentIcons.style.js